(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('EditPasswordResetController', EditPasswordResetController);

  /* ngInject */
  function EditPasswordResetController($state, $stateParams, Flash, formErrorsService, passwordResetService, sessionService) {

    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.form = {};
    vm.passwordResetToken = $stateParams.passwordResetToken;
    vm.updatePasswordReset = updatePasswordReset;
    vm.user = {};

    function updatePasswordReset() {
      passwordResetService(sessionService.getAuthToken()).update({passwordResetToken: vm.passwordResetToken}, {user: vm.user}, _updatePasswordResetSuccess, _updatePasswordResetFailure);
    }

    function _updatePasswordResetFailure(response) {
      Flash.create('danger', 'An error occurred. Please correct the errors on the form below and resubmit.');
      vm.setFormErrors(vm.form, response);
    }

    function _updatePasswordResetSuccess() {
      Flash.create('success', 'Password successfully updated.');
      $state.go('unauthenticated.login');
    }

  }
})();
